import React from 'react'
import { Checkbox, Col, ControlLabel, Row } from 'react-bootstrap'

function CheckboxWithLabel({ label, labelStyle, setValue, defaultValue, value }) {
  return (
    <Row className="w-100 ml-auto mr-auto align-items-center">
      <Col className="mr-2">
        <Checkbox 
          inline={true} 
          onChange={setValue}
          defaultChecked={defaultValue}
          value={value}
        />
      </Col>
      <Col>
        <ControlLabel style={labelStyle}>{ label }</ControlLabel>
      </Col>
    </Row>
  )
}

export default CheckboxWithLabel



// WEBPACK FOOTER //
// ./src/component/Checkbox/CheckBoxWithLabel.js